// SPDX-License-Identifier: Apache-2.0

// Maps known backend LP error substrings (frontend-lp-ui.md §8) to friendlier
// guidance. Falls back to the raw message. Kept as plain strings because these
// mirror backend error text rather than UI chrome.
const LP_ERROR_HINTS: [string, string][] = [
  ["policy is required", "A fee policy is required for CKB deposits."],
  ["invalid owner address", "The owner address is invalid."],
  ["invalid amount", "Enter the amount as a whole number of base units."],
  ["invalid ckbOut", "Enter the amount as a whole number of base units."],
  [
    "building deposit tx",
    "Deposit could not be built — check the 343 CKB minimum and that you hold a single funding cell larger than the amount.",
  ],
  [
    "building withdraw tx",
    "Withdraw could not be built — check the selected cell and amount.",
  ],
  [
    "submitting signed tx",
    "Broadcast was rejected and nothing was sent — try signing again.",
  ],
  ["not configured", "Liquidity pools are not available on this network."],
  ["unsupported asset type", "This asset is not supported for liquidity."],
  ["signedTx is required", "Sign the transaction before submitting."],
  ["previewing owner withdrawable", "Could not read ETH pool state — retry."],
  ["querying total LP shares", "Could not read ETH pool state — retry."],
  ["querying LP shares", "Could not read ETH pool state — retry."],
];

export function mapLPError(err: unknown): string {
  const msg = err instanceof Error ? err.message : String(err);
  for (const [needle, hint] of LP_ERROR_HINTS) {
    if (msg.includes(needle)) {
      return hint;
    }
  }
  return msg;
}

export function isNotConfigured(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err);
  return msg.includes("not configured");
}
